import { render, staticRenderFns } from "./vs-form-geom-dataset.vue?vue&type=template&id=0e477107"
import script from "./vs-form-geom-dataset.vue?vue&type=script&lang=js"
export * from "./vs-form-geom-dataset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports